import React, { Component } from 'react'

class Newsletter extends Component {
  constructor(props) {
    super(props);
    this.state = { firstName: '', lastName: '', email: '', role: '', submitted: false, loading: false };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { firstName, lastName, email, role } = this.state;
    if (!email) return;

    this.setState({ loading: true });
    try {
      await fetch('https://lama.fetchy.vet/api/newsletter/subscribe/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ first_name: firstName, last_name: lastName, email, role }),
      });
      this.setState({ submitted: true });
    } catch (err) {
      // silently fail
    }
    this.setState({ loading: false });
  }

  render() {
    const { firstName, lastName, email, role, submitted, loading } = this.state;

    return (
      <section className="vt-section" id="newsletter">
        <div className="vt-shell-narrow">
          <div className="newsletter-card">
            <span className="eyebrow">Newsletter</span>
            <h2 style={{ marginTop: 6 }}>La newsletter de Charlotte.</h2>
            <p className="muted" style={{ margin: '0 auto 28px' }}>
              Les dernières actus nutritionnelles, une fois par mois, rédigées par Charlotte.
            </p>

            {submitted ? (
              <div style={{ padding: '24px 0' }}>
                <p style={{ fontSize: 18, fontWeight: 500 }}>Merci ! Tu es inscrit·e.</p>
              </div>
            ) : (
              <form onSubmit={this.handleSubmit} style={{ maxWidth: 520, margin: '0 auto', textAlign: 'left' }}>
                <div className="grid2" style={{ gap: '0 14px' }}>
                  <div>
                    <label className="field-lbl">Prénom</label>
                    <input className="field" name="firstName" value={firstName} onChange={this.handleChange} placeholder="Prénom" />
                  </div>
                  <div>
                    <label className="field-lbl">Nom</label>
                    <input className="field" name="lastName" value={lastName} onChange={this.handleChange} placeholder="Nom" />
                  </div>
                </div>
                <label className="field-lbl">Email</label>
                <input className="field" type="email" name="email" value={email} onChange={this.handleChange} placeholder="toi@clinique.fr" required />
                <label className="field-lbl">Je suis…</label>
                <input className="field" name="role" value={role} onChange={this.handleChange} placeholder="Vétérinaire, ASV, particulier…" />
                <button
                  type="submit"
                  className="vt-btn vt-btn-call vt-btn-lg w100"
                  style={{ marginTop: 18 }}
                  disabled={loading}
                >
                  {loading ? 'Envoi…' : "Je m'abonne"}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    )
  }
}

export default Newsletter;
